import axios from 'axios';
import moment from 'moment';

export async function init() {

}

export async function getAllStats({ dispatch }) {
	await dispatch('getListings');
	await dispatch('getVehicleStats');
	await dispatch('getLeadStats');
}

export async function getListings({ commit, state }) {
	commit('SET_LOADING', true);

	const data = await metricsApiCall('/listings', state.filter);

	commit('SET_LISTINGS', data.data);
	commit('SET_LOADING', false);
}

export async function getVehicleStats({ commit, state }) {

	commit('SET_LOADING', true);

	const data = await metricsApiCall('/vehicles', state.filter);

	commit('SET_VEHICLESTATS', data);
	commit('SET_LOADING', false);
}

export async function getLeadStats({ commit, state }) {

	commit('SET_LOADING', true);

	const data = await metricsApiCall('/leads', state.filter);

	commit('SET_LEADSTATS', data);
	commit('SET_LOADING', false);
}

export async function getDateRange({ commit }) {
	// commit('SET_LOADING', true);
	// const { data } = await axios.get('/metrics/daterange');

	let from = moment().subtract(30, 'days');
	const to = moment().subtract(2, 'days');

	const diff = to.clone().diff(from, 'days');

	// max 30 days so we don't load too much data
	if (diff > 30) {
		from = to.clone().subtract(30, 'days');
	}

	commit('SET_FILTER_DATERANGE', {
		max: moment().format('DD.MM.YYYY'),
	});
	commit('SET_FILTER', {
		from: from.format('DD.MM.YYYY'),
		to: to.format('DD.MM.YYYY'),
	});
	// commit('SET_LOADING', false);
}

async function metricsApiCall(endpoint, filter) {
	const { data } = await axios.get(`/metrics${endpoint}`, {
		params: {
			filter:
			{
				from: moment(filter.from, 'DD.MM.YYYY').format('YYYY-MM-DD'),
				to: moment(filter.to, 'DD.MM.YYYY').format('YYYY-MM-DD'),
			},
		},
	});

	return data;
}
